import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { useAuthStore } from '@/stores/auth.store'

export const Route = createFileRoute('/_authenticated')({
  component: Layout,
})

function Layout() {
  const navigate = useNavigate()
  const auth = useAuthStore()

  useEffect(() => {
    if (!auth.isAuthenticated || !auth.user) {
      void navigate({ to: '/connexion' })
      return
    }
  }, [navigate, auth.isAuthenticated, auth.user])

  return <Outlet />
}
